export const USER_BOOKMARKS_PANEL_SCROLL_ELEMENT_ID =
  "user-bookmarks-panel-header";
export const MAX_IMAGES_TO_SHOW = 6;
